import { Badge, Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import ProductBundle from './ProductBundle';
import ProductSatuan from './ProductSatuan';

export default function UploadSatuan() {
    return (
        <Box>
            <Text fontWeight={'bold'} fontSize={'20px'} mb={'8px'}>
                Upload Satuan
            </Text>
            <Text fontSize={'14px'}>Cari produk Paragon dan sesuaikan kodenya jika berbeda dengan kode toko</Text>

            <Tabs mt="44px" variant={'sagi-rounded'}>
                <TabList>
                    <Tab>Product Satuan</Tab>
                    <Tab>
                        Product Bundle
                        <Badge
                            rounded={'full'}
                            textTransform={'capitalize'}
                            color={'semantic.100'}
                            bg={'danger.500'}
                            p={'4px 6px'}
                            ml={'8px'}
                        >
                            Baru!
                        </Badge>
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel pb={0}>
                        <ProductSatuan />
                    </TabPanel>
                    <TabPanel pb={0}>
                        <ProductBundle />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
